import ax from "@/api/auth";
import store from "@/store";
import router from "@/router";
import i18n from "@/i18n";

function socialLogin(req, isSignup) {
  return new Promise((resolve) => {
    ax.socialLogin(req, (flag, data) => {
      if (flag) {
        resolve([true, data]);
      } else {
        resolve([false, data]);
      }
    });
  });
}

async function socialSignup(form) {
  return new Promise((resolve) => {
    ax.socialSignup(form, (flag, data) => {
      if (flag) {
        resolve([true, data]);
      } else {
        resolve([false, data]);
      }
    });
  });
}

export { socialLogin, socialSignup };
